import { styled } from "goober";
import type { CSSProperties, MouseEvent, Ref } from "react";
import {
  DragIndicator,
  dragIndicatorHidden,
  dragIndicatorShown,
} from "./DragIndicator";
import { PressButton } from "./PressButton";

const Handle = styled(PressButton)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 12px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  & [data-drag-indicator] {
    width: 8px;
    background: transparent;
    ${dragIndicatorHidden("translateX(-4px)")}
  }
  & [data-drag-indicator] svg {
    display: block;
  }
  & [data-drag-indicator] path {
    d: path("M 4 1 L 4 16 L 4 31");
    stroke: var(--alpha16);
    transition:
      d var(--motion-base) var(--ease-out),
      stroke var(--motion-fast) var(--ease-out);
  }
  &:hover [data-drag-indicator],
  &:focus-visible [data-drag-indicator],
  &[aria-expanded="false"] [data-drag-indicator] {
    ${dragIndicatorShown}
  }
  &:hover [data-drag-indicator] path,
  &:focus-visible [data-drag-indicator] path {
    d: path("M 6 9 L 2 16 L 6 23");
    stroke: var(--alpha16);
  }
  &[aria-expanded="false"]:hover [data-drag-indicator] path,
  &[aria-expanded="false"]:focus-visible [data-drag-indicator] path {
    d: path("M 2 9 L 6 16 L 2 23");
  }
  &:focus-visible {
    outline: none;
  }
  &:focus-visible [data-drag-indicator] {
    outline: 2px solid var(--control-bg);
    outline-offset: 3px;
  }
`;

export function SidebarToggle({
  ref,
  collapsed,
  onToggle,
  onMouseEnter,
  onMouseLeave,
  style,
}: {
  ref?: Ref<HTMLButtonElement>;
  collapsed: boolean;
  onToggle: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: (event: MouseEvent<HTMLButtonElement>) => void;
  style?: CSSProperties;
}) {
  return (
    <Handle
      ref={ref}
      data-sidebar-toggle
      aria-label={collapsed ? "Pin navigation open" : "Collapse navigation"}
      aria-expanded={!collapsed}
      onPress={onToggle}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={style}
    >
      <DragIndicator
        data-drag-indicator
        data-orientation="horizontal"
        aria-hidden
      >
        <svg width="8" height="32" viewBox="0 0 8 32" fill="none">
          <path
            d="M 4 1 L 4 16 L 4 31"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </DragIndicator>
    </Handle>
  );
}
